import React, { useState } from "react";
import {
  Typography,
  Chip,
  Stack,
  Accordion,
  AccordionDetails,
  Button,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomAccordionSummary from "styles/customAccordionSummary";

const STATUS_FILTER_OPTIONS = [
  "All",
  "Active",
  "Latest Version",
  "No Release",
  "Pending Release",
  "Released",
];

export default function QuickFilters({
  setSelectedStatus,
  setSelectedAssignee,
  selectedStatus,
  selectedAssignee,
  handleAccordionToggle,
  onFilterChange,
  resetFilter,
}) {
  const [expanded, setExpanded] = useState(false);

  /** Handles assignee quick-filter selection changes. */
  const handleAssigneeClick = (assignee) => {
    setSelectedAssignee(assignee);
    onFilterChange("assignee", assignee);
  };

  /** Handles status quick-filter selection changes. */
  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    onFilterChange("status", status);
  };

  /** Toggles the quick-filter accordion state and notifies the parent. */
  const handleAccordionChange = () => {
    setExpanded(!expanded);
    handleAccordionToggle();
  };

  const isResetVisible = selectedAssignee !== "All" || selectedStatus !== "All";

  return (
    <div>
      <Accordion
        sx={{
          ".MuiAccordionSummary-content.Mui-expanded": {
            margin: "0px",
          },
        }}
        expanded={expanded}
        onChange={handleAccordionChange}
      >
        <CustomAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ mb: 0 }}
            px={(theme) => theme.spacing(1)}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Quick Filters:
            </Typography>
            {isResetVisible && (
              <Button onClick={resetFilter} color="selectedChip">
                Reset
              </Button>
            )}
            {/* Display selected filters only when the accordion is collapsed */}

            {!expanded && selectedStatus !== "All" && (
              <Typography variant="body2">
                <span style={{ fontWeight: "bold" }}>By Status:</span>{" "}
                {selectedStatus}
              </Typography>
            )}
            {!expanded && selectedAssignee !== "All" && (
              <Typography variant="body2">
                <span style={{ fontWeight: "bold" }}>By Assignee:</span>{" "}
                {selectedAssignee}
              </Typography>
            )}
          </Stack>
        </CustomAccordionSummary>
        <AccordionDetails>
          <Stack
            direction="row"
            spacing={1}
            sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
          >
            <Tooltip title="Filter policies by lifecycle and release status">
              <Typography
                variant="subtitle1"
                sx={{ width: 125, fontWeight: "bold" }}
              >
                By Status:
              </Typography>
            </Tooltip>
            {STATUS_FILTER_OPTIONS.map((status) => (
              <Chip
                sx={{ minWidth: 125 }}
                key={status}
                label={status}
                onClick={() => handleStatusClick(status)}
                color={selectedStatus === status ? "selectedChip" : "chip"}
              />
            ))}
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
          >
            <Tooltip title="Filter by assignee">
              <Typography
                variant="subtitle1"
                sx={{ width: 125, fontWeight: "bold" }}
              >
                By Assignee:
              </Typography>
            </Tooltip>
            {["All", "Assigned to me", "Unassigned"].map((assignee) => (
              <Chip
                sx={{ minWidth: 125 }}
                key={assignee}
                label={assignee}
                onClick={() => handleAssigneeClick(assignee)}
                color={selectedAssignee === assignee ? "selectedChip" : "chip"}
              />
            ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
